export const ALIGNMENTS: {key: string; label: string}[] = [
	{key: 'LG', label: 'Принципиальный добрый'},
	{key: 'NG', label: 'Нейтральный добрый'},
	{key: 'CG', label: 'Хаотичный добрый'},
	{key: 'LN', label: 'Принципиальный нейтральный'},
	{key: 'N', label: 'Нейтральный'},
	{key: 'CN', label: 'Хаотичный нейтральный'},
	{key: 'LE', label: 'Принципиальный злой'},
	{key: 'NE', label: 'Нейтральный злой'},
	{key: 'CE', label: 'Хаотичный злой'},
];

export const alignmentLabel = (key: string) => ALIGNMENTS.find((alignment) => alignment.key === key)?.label || key;
